import axios from 'axios';

const api = axios.create({ baseURL: '/api' });

export const enviarPresupuesto = (data, fotos = []) => {
  const fd = new FormData();
  Object.entries(data).forEach(([k, v]) => {
    if (v !== null && v !== undefined && v !== '') fd.append(k, v);
  });
  fotos.forEach(file => fd.append('fotos', file));
  return api.post('/presupuesto', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
    maxBodyLength: 64 * 1024 * 1024
  });
};

export const enviarContacto = (data) => api.post('/contacto', data);

export const buscarDirecciones = (q) => api.get('/places/search', { params: { q } });
